export default __webpack_public_path__ + "static/media/Belt of the Fallen Empire.cd6c7fdc.jpg";